import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SCREEN_ID_LISTING_REQUEST_TOUR_EMAIL,
} from 'client/constants/screenIds';

import SrPage from 'client/components/SrPage';
import SrSimpleMessage from 'client/components/SrSimpleMessage';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

@withTransitionHook
@withScreenId(SCREEN_ID_LISTING_REQUEST_TOUR_EMAIL)
@withScrollToTop
class RequestTourEmail extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Request Tour Email | Sunroom Rentals',
  })

  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  }

  _onClickCTAButton = () => {
    const { history, match } = this.props;
    history.push(`/listing/${match.params.listingId}?tourRequestEmailSent=true`);
  }

  render() {
    return (
      <SrPage>
        <div className='flex-center'>
          <SrSimpleMessage
            className='requestTourEmail'
            iconUrl='/images/mail-send-green.svg'
            headline='Tour request sent!'
            // eslint-disable-next-line max-len
            message='An email was just sent to the agent who manages this home. Look for an email response from them soon!'
            buttonText='ok, thanks'
            onClickButton={this._onClickCTAButton}
          />
        </div>
      </SrPage>
    );
  }
}

RequestTourEmail.displayName = 'RequestTourEmail';

export default RequestTourEmail;
